import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from "react";
import { Button } from "@/components/Buttons";
import routes from "@/lib/routes";
import processStyles from "@/styles/Process.module.scss";
import { useRouter } from "next/router";
import { useCallback } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

var IconComplete = function IconComplete(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsx("circle", {
      cx: "30",
      cy: "30",
      r: "30",
      transform: "translate(2 2)",
      fill: "none",
      stroke: "#09f",
      strokeWidth: "3"
    }), /*#__PURE__*/_jsx("path", {
      d: "M18.674,33.177,27.1,43.116l18.862-20",
      fill: "none",
      stroke: "#09f",
      strokeWidth: "3",
      fillOpacity: "0"
    })]
  }));
};

IconComplete.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "64",
  height: "64",
  viewBox: "0 0 64 64"
};
export default function CompleteInquiry() {
  var router = useRouter();
  var handleClick = useCallback(function () {
    router.push(routes.home);
  }, []);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs("div", {
      className: "".concat(processStyles.header, " ").concat(processStyles.cancelMb),
      children: [/*#__PURE__*/_jsx("div", {
        className: processStyles.icon,
        children: /*#__PURE__*/_jsx(IconComplete, {})
      }), /*#__PURE__*/_jsx("h4", {
        className: processStyles.heading,
        children: "\u304A\u554F\u3044\u5408\u308F\u305B\u3092\u9001\u4FE1\u3057\u307E\u3057\u305F"
      })]
    }), /*#__PURE__*/_jsx(Button, {
      fillColor: true,
      large: true,
      fontFixed: true,
      onClick: handleClick,
      children: "\u30C8\u30C3\u30D7\u3078\u623B\u308B"
    })]
  });
}